export const memberTypeList = [
    {
      value: 1,
      label: "海马会员卡",
    },
    {
      value: 2,
      label: "天赋卡",
    },
    {
        value: 3,
        label: "聊天卡",
      },
      {
        value: 4,
        label: "定制卡",
      },
      {
        value: 5,
        label: "汇合空间用户会员卡",
      },
      {
        value: 6,
        label: "空间管理端会员",
      },
      {
        value: 7,
        label: "空间管理端超级会员",
      },
      {
        value: 21,
        label: "教练vip",
      },
      {
        value: 22,
        label: "教练svip",
      },
      {
        value: 31,
        label: "门店vip",
      },
      {
        value: 32,
        label: "门店svip",
      },
      {
        value: 41,
        label: "心悦会员",
      }
  ]

  